import React, { Component } from 'react'
import { requestAPI } from '../../data/api'
import ScreenshotReviewCard from './ScreenshotReviewCard'
import Loading from '../../generic/Loading'

const BATCH_LIMIT = 10

class ScreenshotReview extends Component {
	state = {
		violations: [],
		loading: false,
		error: null,
		exhausted: false,
		stats: null,
	}

	componentDidMount() {
		this.loadBatch()
		this.refreshStats()
	}

	refreshStats = async () => {
		try {
			const stats = await requestAPI(
				'/violations/screenshot-review/stats',
				'GET',
			)
			if (stats && typeof stats.pendingReview === 'number') {
				this.setState({ stats })
			}
		} catch (err) {
			// Non-critical — just don't show the count.
		}
	}

	loadBatch = async () => {
		this.setState({ loading: true, error: null })
		try {
			const batch = await requestAPI(
				'/violations/screenshot-review/claim',
				'POST',
				{ limit: BATCH_LIMIT },
			)
			if (!Array.isArray(batch)) {
				this.setState({
					loading: false,
					error: (batch && batch.error) || 'Failed to load batch',
				})
				return
			}
			const existingIds = new Set(
				this.state.violations.map((v) => v.violation_id),
			)
			const merged = [
				...this.state.violations,
				...batch.filter((v) => !existingIds.has(v.violation_id)),
			]
			this.setState({
				violations: merged,
				loading: false,
				exhausted: batch.length === 0,
			})
		} catch (err) {
			this.setState({ loading: false, error: 'Failed to load batch' })
		}
	}

	handleReviewed = (violationId) => {
		this.setState((prev) => ({
			violations: prev.violations.filter(
				(v) => v.violation_id !== violationId,
			),
			exhausted: false,
		}))
		this.refreshStats()
	}

	render() {
		const { violations, loading, error, exhausted, stats } = this.state
		return (
			<div id='screenshot-review'>
				<h1 className='heading'>Screenshot Review</h1>
				<p style={{ opacity: 0.7 }}>
					Review auto-captured screenshots. Approve to keep, drop an image to
					upload a manual replacement, or reject the case if it's no longer on
					site.
				</p>
				<p>
					Currently claimed: {violations.length}
					{stats && (
						<span style={{ marginLeft: '12px', opacity: 0.7 }}>
							· {stats.pendingReview} violations awaiting review
						</span>
					)}
				</p>
				{violations.map((violation) => (
					<div key={violation.violation_id} style={{ marginBottom: '20px' }}>
						<ScreenshotReviewCard
							violation={violation}
							onReviewed={this.handleReviewed}
						/>
					</div>
				))}
				{loading && (
					<div style={{ textAlign: 'center', margin: '40px 0' }}>
						<Loading width='30' />
					</div>
				)}
				{error && (
					<p style={{ color: 'red', textAlign: 'center' }}>{error}</p>
				)}
				{!loading && violations.length === 0 && exhausted && (
					<h2 style={{ textAlign: 'center', margin: '80px 0', opacity: 0.6 }}>
						Queue is empty
					</h2>
				)}
				<div style={{ textAlign: 'center', margin: '20px 0' }}>
					<button
						className='btn primary'
						onClick={this.loadBatch}
						disabled={loading}
					>
						{violations.length === 0 ? 'Load batch' : 'Load more'}
					</button>
				</div>
			</div>
		)
	}
}

export default ScreenshotReview
